import angular from 'angular'
import moment from 'moment-timezone'

angular.module('pub.bundle.step1', []).controller('Step1Ctrl', Step1Ctrl)

/** @ngInject */
function Step1Ctrl(
  $scope,
  $timeout,
  $q,
  $state,
  $rootScope,
  $stateParams,
  BundleService,
  UploadService,
  BundleCache,
  SetsService,
  CsvService,
  TranslatorService,
  ChannelsService,
  MarketplaceService,
) {
  var vm = this
  vm.model = {}
  vm.collectibles = []
  vm.products = []
  vm.parentId = $stateParams.parentId
  vm.channelId = $stateParams.channelId
  vm.isChannelBundle = !!$stateParams.channelId
  vm.isEvent = $stateParams.event
  vm.loadT = false
  vm.loadTM = false
  vm.loadL = false
  vm.pathImgL = ''
  vm.pathImgT = ''
  vm.pathImgTM = ''
  vm.isUpload = true
  vm.isOpen = false
  vm.isOpen1 = false
  vm.isOpen2 = false
  vm.isChannelLevel = false
  vm.aqc = false
  vm.variants = [
    {
      id: 0,
      name: 'Tall Box',
    },
    {
      id: 1,
      name: 'Short Box',
    },
    {
      id: 2,
      name: 'Other',
    },
  ]

  vm.types = [
    {
      id: 1,
      name: 'Standard',
    },
    {
      id: 2,
      name: 'Award',
    },
    {
      id: 3,
      name: 'Starter',
    },
    {
      id: 4,
      name: 'Pre-Sale',
    },
    {
      id: 5,
      name: 'Release',
    },
    {
      id: 6,
      name: 'Mega Pack',
    },
    {
      id: 7,
      name: 'Spotify',
    },
    {
      id: 8,
      name: 'Youtube',
    },
    {
      id: 9,
      name: 'Tiktok',
    },
    {
      id: 10,
      name: 'Youtube Subscribe to Channel',
    },
  ]

  vm.parentTypes = vm.types.filter(function (t) {
    return t.id !== 10
  })

  // 8 is standard Youtube (Stream Video), 10 is Subscribe
  vm.youtubeActions = [
    {
      id: 8,
      name: 'Stream Video',
    },
    {
      id: 10,
      name: 'Subscribe to Channel',
    },
  ]

  vm.maxTypes = [
    {
      id: 0,
      name: 'Max per user',
    },
    {
      id: 1,
      name: 'Max per promo code',
    },
    {
      id: 2,
      name: 'Max per user segment match',
    },
    {
      id: 3,
      name: 'Max per day',
    },
  ]

  vm.priceTypes = [
    {
      id: 1,
      name: 'Free',
    },
    {
      id: 2,
      name: 'Cash',
    },
  ]

  vm.title = null
  vm.priceType = vm.priceTypes[1].id

  vm.segmentations = []
  vm.bundleSegmentations = []

  vm.model.k = vm.types[0].id
  vm.bundleParentType = vm.model.k
  vm.model['k-mpu'] = vm.maxTypes[0].id

  var whichPage = window.location.pathname
  vm.isMegaBundlesPage = whichPage.indexOf('megabundles') !== -1

  vm.openCalendar = function (e, type) {
    e.preventDefault()
    e.stopPropagation()

    if (type === 1) {
      vm.isOpen = true
    } else if (type === 2) {
      vm.isOpen1 = true
    } else {
      vm.isOpen2 = true
    }
  }

  vm.bundlesTranslations = []
  function loadTranslations() {
    BundleService.listTranslations($stateParams.id).then(function (result) {
      vm.bundlesTranslations = result.results
    })
  }

  loadTranslations()

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  //start
  BundleCache.clear()

  // Youtube Video URL validation
  vm.validateYoutubeURL = function (url) {
    if (!url) return (vm.youtubeError = '')

    // Only allow direct video links (with v= or youtu.be)
    // Block Shorts and Playlist explicitly
    var shortsRegex = /youtube\.com\/shorts\//i
    var playlistRegex = /[?&]list=/i
    var validVideoRegex =
      /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9_-]{11}(\S+)?$/

    if (shortsRegex.test(url)) {
      vm.youtubeError = 'Shorts not supported'
    } else if (playlistRegex.test(url)) {
      vm.youtubeError = 'Playlist not supported'
    } else if (!validVideoRegex.test(url)) {
      vm.youtubeError = 'Invalid Video URL'
    } else {
      vm.youtubeError = ''
    }
  }

  // Youtube Channel URL validation
  vm.validateYoutubeChannelURL = function (url) {
    if (!url) return (vm.youtubeChannelError = '')

    var validChannelRegex = /^UC[a-zA-Z0-9_-]{22}$/
    if (!validChannelRegex.test(url)) {
      vm.youtubeChannelError = 'Invalid Channel ID'
    } else {
      vm.youtubeChannelError = ''
    }
  }

  vm.onParentTypeChange = function () {
    if (vm.bundleParentType === 8) {
      vm.model.k = 8
    } else {
      vm.model.k = vm.bundleParentType
    }
  }

  //function bind
  vm.back = function () {
    if (vm.isEvent) {
      $state.go('admin.event')
      return
    }
    $state.go('pub.bundles', {
      parentId: $stateParams.parentId,
      channelId: $stateParams.channelId,
    })
  }

  // var makeTranslation = function (t, txt, currentTranslations, paramsId, route) {
  //   if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //     if (vm.title === t && vm.description === txt) {
  //       return
  //     }
  //   }

  //   TranslatorService.translateProductAllLanguage(t, txt, vm.glossaryName).then(function (res) {
  //     var languages = ['ja', 'ko', 'zh', 'zh-TW']

  //     for (var i = 0; i < currentTranslations.length; i++) {
  //       for (var key in res.t.results) {
  //         if (currentTranslations[i].comm === 'JP' && key.indexOf('ja') !== -1) {
  //           languages.remove('ja')
  //         }
  //         if (currentTranslations[i].comm === 'KR' && key.indexOf('ko') !== -1) {
  //           languages.remove('ko')
  //         }
  //         if (currentTranslations[i].comm === 'SC' && key.indexOf('zh') !== -1) {
  //           languages.remove('zh')
  //         }
  //         if (currentTranslations[i].comm === 'TC' && key.indexOf('zh-TW') !== -1) {
  //           languages.remove('zh-TW')
  //         }
  //       }
  //     }

  //     if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //       var promises = []

  //       for (var i = 0; i < currentTranslations.length; i++) {
  //         if (currentTranslations[i].comm === 'SC' && res.t.results) {
  //           var exist = _.find(languages, 'zh')
  //           if (exist) {
  //             promises.push(
  //               BundleService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'SC',
  //                 t: res.t.results.zh,
  //                 txt: res.txt.results.zh,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               BundleService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.zh,
  //                 txt: res.txt.results.zh,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'TC' && res.t.results) {
  //           var exist = _.find(languages, 'zh-TW')
  //           if (exist) {
  //             promises.push(
  //               BundleService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'TC',
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt.results['zh-TW'],
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               BundleService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt.results['zh-TW'],
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'KR' && res.t.results) {
  //           var exist = _.find(languages, 'ko')
  //           if (exist) {
  //             promises.push(
  //               BundleService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'KR',
  //                 t: res.t.results.ko,
  //                 txt: res.txt.results.ko,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               BundleService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ko,
  //                 txt: res.txt.results.ko,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'JP' && res.t.results) {
  //           var exist = _.find(languages, 'ja')
  //           if (exist) {
  //             promises.push(
  //               BundleService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'JP',
  //                 t: res.t.results.ja,
  //                 txt: res.txt.results.ja,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               BundleService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ja,
  //                 txt: res.txt.results.ja,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //       }

  //       $q.all(promises)
  //         .then(function () {})
  //         .catch(function (err) {
  //           swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //         })
  //     }

  //     var promises = []

  //     for (var i = 0; i < languages.length; i++) {
  //       if (languages[i] === 'zh' && res.t.results) {
  //         promises.push(
  //           BundleService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'SC',
  //             t: res.t.results.zh,
  //             txt: res.txt.results.zh,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'zh-TW' && res.t.results) {
  //         promises.push(
  //           BundleService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'TC',
  //             t: res.t.results['zh-TW'],
  //             txt: res.txt.results['zh-TW'],
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ko' && res.t.results) {
  //         promises.push(
  //           BundleService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'KR',
  //             t: res.t.results.ko,
  //             txt: res.txt.results.ko,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ja' && res.t.results) {
  //         promises.push(
  //           BundleService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'JP',
  //             t: res.t.results.ja,
  //             txt: res.txt.results.ja,
  //           }),
  //         )
  //       }
  //     }

  //     $q.all(promises)
  //       .then(function () {})
  //       .catch(function () {
  //         swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //       })
  //   })
  // }

  vm.save = function (options, isValid, click) {
    if (vm.model.k !== 7) {
      vm.model['s-url'] = ''
    }
    if (vm.model.k !== 8 && vm.model.k !== 10) {
      vm.model['yt-url'] = ''
      vm.model['yt-ch-url'] = ''
    }
    if (vm.model.k !== 10) {
      vm.model['yt-ch-url'] = ''
    }
    if (vm.model.k !== 9) {
      vm.model['tk-url'] = ''
    }
    if (vm.model.k === 7 || vm.model.k === 8 || vm.model.k === 9 || vm.model.k === 10) {
      vm.model.mpu = 1
    }

    // Youtube validation on save
    if ((vm.model.k === 8 || vm.model.k === 10) && vm.youtubeError) {
      toastr.warning('Youtube Video: ' + vm.youtubeError)
      $('#yt-url').focus()
      return
    }
    if (vm.model.k === 10 && vm.youtubeChannelError) {
      toastr.warning('Youtube Channel: ' + vm.youtubeChannelError)
      $('#yt-ch-url').focus()
      return
    }

    if (vm.model['ts-p'] !== undefined || vm.model['ts-p'] !== null || vm.model['ts-p'] !== '') {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        vm.model['ts-p'] = date
      } else {
        if (click) {
          toastr.warning('Date field invalid!')
          vm.isOpen = true
          $('#date1').focus()
        }
        return
      }
    } else {
      toastr.warning('You need select Publish At!')
      return
    }

    if (vm.model.k === 7 || vm.model.k === 8 || vm.model.k === 9 || vm.model.k === 10) {
      if (vm.model.k === 7 && !vm.model['s-url']) {
        toastr.warning(`Spotify URL is required`)
        $('#s-url').focus()
        return
      }

      if (vm.model.k === 8 && !vm.model['yt-url']) {
        toastr.warning(`Youtube URL is required`)
        $('#yt-url').focus()
        return
      }
      if (vm.model.k === 9 && !vm.model['tk-url']) {
        toastr.warning(`Tiktok URL is required`)
        $('#tk-url').focus()
        return
      }
      if (vm.model.k === 10) {
        if (!vm.model['yt-ch-url']) {
          toastr.warning(`Youtube Channel ID is required`)
          $('#yt-ch-url').focus()
          return
        }
      }

      if (!vm.data3 || !isDate(vm.data3)) {
        toastr.warning(
          `Expiration At is required for ${
            vm.model.k === 7
              ? 'Spotify'
              : vm.model.k === 8
                ? 'Youtube'
                : vm.model.k === 9
                  ? 'Tiktok'
                  : vm.model.k === 10
                    ? 'Youtube Channel'
                    : ''
          } bundles!`,
        )
        vm.isOpen2 = true
        $('#date3').focus()
        return
      }
    }

    if (vm.model['ts-f'] !== undefined || vm.model['ts-f'] !== null || vm.model['ts-f'] !== '') {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        vm.model['ts-f'] = date
      }
    } else {
      vm.model['ts-f'] = null
    }

    if (vm.model['ts-x'] !== undefined || vm.model['ts-x'] !== null || vm.model['ts-x'] !== '') {
      if (isDate(vm.data3)) {
        var date = parseInt(new Date(new Date(vm.data3).setSeconds(0)).getTime() * 1000)
        vm.model['ts-x'] = date
      }
    } else {
      vm.model['ts-x'] = null
    }

    if (vm.model['ts-f'] === 0) {
      vm.model['ts-f'] = null
    }

    if (vm.model['ts-x'] === 0) {
      vm.model['ts-x'] = null
    }

    if (!isValid) {
      toastr.warning('Complete all fields!')
      $('html, body').animate({ scrollTop: 0 }, 1000)
      return
    }

    delete vm.model.qo

    if (vm.model.c === null || vm.model.c === undefined) {
      vm.model.c = 0
    }

    if (vm.model.cd === null || vm.model.cd === undefined) {
      vm.model.cd = 0
    }

    if (vm.priceType === 1) {
      vm.model['id-prod'] = null
      // always free if price type 1
      vm.model.c = 0
    } else {
      vm.model.c = 0
    }

    if (vm.aqc) {
      vm.model.st = 10
    } else {
      if (vm.model.st === 10) {
        vm.model.st = 0
      }
    }

    if (vm.isChannelLevel) {
      vm.model['id-s'] = null
      if (vm.set && vm.set.ch) {
        vm.model['id-ch'] = vm.set.ch.id
      } else {
        vm.model['id-ch'] = parseInt(vm.channelId)
      }
    } else {
      if (!vm.set) {
        vm.model['id-s'] = parseInt($('#setSelect').select2('val'))
      } else {
        vm.model['id-s'] = vm.set.id
      }
      vm.model['id-ch'] = null
    }

    if (vm.channelId) {
      BundleService.updateBundle($stateParams.id, vm.model).then(
        function () {
          if (
            (vm.model.ct === undefined || vm.model.ct === null) &&
            vm.model.mpu === 1 &&
            vm.model.c === 0
          ) {
            vm.onboarding = true
          } else {
            vm.onboarding = false
          }

          // makeTranslation(vm.model.t, vm.model.txt, vm.bundlesTranslations, vm.model.id, '')

          toastr.success('Saved')

          if (vm.isEvent) {
            $state.go('pub.bundles.step2', {
              parentId: $stateParams.parentId,
              id: $stateParams.id,
              event: $stateParams.event,
              create: $stateParams.create,
              post: $stateParams.post,
            })
          }
        },
        function (error) {
          swal(error.error.message, '', 'error')
          return
        },
      )
    } else {
      BundleService.update($stateParams.parentId, $stateParams.id, vm.model).then(
        function () {
          if (
            (vm.model.ct === undefined || vm.model.ct === null) &&
            vm.model.mpu === 1 &&
            vm.model.c === 0
          ) {
            vm.onboarding = true
          } else {
            vm.onboarding = false
          }

          makeTranslation(vm.model.t, vm.model.txt, vm.bundlesTranslations, vm.model.id, '')

          toastr.success('Saved')

          if (vm.isEvent) {
            $state.go('pub.bundles.step2', {
              parentId: $stateParams.parentId,
              id: $stateParams.id,
              event: $stateParams.event,
              create: $stateParams.create,
              post: $stateParams.post,
            })
          }
        },
        function (error) {
          swal(error.error.message, '', 'error')
          return
        },
      )
    }
  }

  function load() {
    BundleService.getId($stateParams.parentId, $stateParams.id).then(success)

    function success(result) {
      var bundle = result.results
      vm.model = bundle
      vm.title = bundle.t
      vm.description = bundle.txt
      vm.filesObj = bundle.obj
      vm.priceType = vm.model['id-prod'] !== undefined ? 2 : 1
      if (bundle['ts-p'] !== undefined && bundle['ts-p'] !== 0) {
        bundle['ts-p'] = bundle['ts-p']
          .toString()
          .substring(0, bundle['ts-p'].toString().length - 3)
        vm.model['ts-p'] = new Date(parseInt(bundle['ts-p']))
        vm.data1 = angular.copy(vm.model['ts-p'])
      }
      if (bundle['ts-f'] !== undefined && bundle['ts-f'] !== 0) {
        bundle['ts-f'] = bundle['ts-f']
          .toString()
          .substring(0, bundle['ts-f'].toString().length - 3)
        vm.model['ts-f'] = new Date(parseInt(bundle['ts-f']))
        vm.data2 = angular.copy(vm.model['ts-f'])
      }
      if (bundle['ts-x'] !== undefined && bundle['ts-x'] !== 0) {
        bundle['ts-x'] = bundle['ts-x']
          .toString()
          .substring(0, bundle['ts-x'].toString().length - 3)
        vm.model['ts-x'] = new Date(parseInt(bundle['ts-x']))
        vm.data3 = angular.copy(vm.model['ts-x'])
      }
      if (vm.model.bv === null || vm.model.bv === '') {
        vm.bv = 0
      } else if (vm.model.bv === 'box_02.dae') {
        vm.bv = 1
      } else {
        vm.bv = 2
      }

      if (
        (vm.model.ct === undefined || vm.model.ct === null) &&
        vm.model.mpu === 1 &&
        vm.model.c === 0
      ) {
        vm.onboarding = true
      } else {
        vm.onboarding = false
      }

      if (vm.model.st === 10) {
        vm.aqc = true
      }

      if (vm.model['id-ch']) {
        vm.isChannelLevel = true
      } else {
        vm.isChannelLevel = false
      }

      vm.pathImgL = bundle['img-l']
      vm.pathImgT = bundle['img-t']
      vm.pathImgTM = bundle['img-tm']
      vm.isUpload = false

      if ($stateParams.parentId !== '0') {
        SetsService.get($stateParams.parentId).then(function (result) {
          vm.set = result.results
          vm.glossaryName = vm.set.ch['id-gl']
          var data = result.results
          if (data['k-prod'] === 1) {
            vm.typeSet = 'Sticker'
          } else if (data['k-prod'] === 2) {
            vm.typeSet = 'Card'
          } else {
            vm.typeSet = 'Figure'
          }
        })
      } else {
        ChannelsService.get(vm.channelId).then(function (result) {
          vm.channel = result.results
          vm.glossaryName = vm.channel['id-gl']
        })
      }

      BundleService.listBundleSegmentation($stateParams.id).then(function (result) {
        vm.bundleSegmentations = generateType(result.results)
      })

      BundleService.listSegmentation().then(function (result) {
        vm.segmentations = _.filter(result.results, { arch: false })
      })

      BundleService.listProductsPublished().then(function (result) {
        vm.products = result.results
      })

      // Set bundleParentType for UI
      if (vm.model.k === 10) {
        vm.bundleParentType = 8
      } else {
        vm.bundleParentType = vm.model.k
      }
    }
  }

  vm.changeVariant = function (item) {
    if (item === 0) {
      vm.model.bv = ''
    } else if (item === 1) {
      vm.model.bv = 'box_02.dae'
    }
  }

  var watch = $scope.$watch('vm.fileImgT', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadT = false
      return
    }

    if (newVal === null) {
      vm.loadT = false
    }

    vm.loadT = true
    UploadService.save('bundles', newVal, 'img-t', vm.model.id).then(function (fileName) {
      vm.loadT = false
      vm.model['img-t'] = fileName
      vm.pathImgT = fileName
    })
  })

  vm.onbord = function () {
    vm.model.ct = null
    vm.model.mpu = 1
    vm.model.c = 0
  }

  var watch1 = $scope.$watch('vm.fileImgL', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadL = false
      return
    }

    if (newVal === null) {
      vm.loadL = false
    }

    vm.loadL = true
    UploadService.save('bundles', newVal, 'img-l', vm.model.id).then(function (fileName) {
      vm.loadL = false
      vm.model['img-l'] = fileName
      vm.pathImgL = fileName
    })
  })

  var watch2 = $scope.$watch('vm.fileImgTM', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadTM = false
      return
    }

    if (newVal === null) {
      vm.loadTM = false
    }

    vm.loadTM = true
    UploadService.save('bundles', newVal, 'img-tm', vm.model.id).then(function (fileName) {
      vm.loadTM = false
      vm.model['img-tm'] = fileName
      vm.pathImgTM = fileName
    })
  })

  var watch3 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch4 = $scope.$watch('vm.data2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch5 = $scope.$watch('vm.data3', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate3NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate3LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  //if bundle type is spotify then change to free pack
  var watch6 = $scope.$watch('vm.model.k', function (newVal) {
    if (newVal === 7 || newVal === 8 || newVal === 9 || newVal === 10) {
      vm.priceType = 1
      vm.model['id-prod'] = null
      vm.model.mpu = 1
    }
  })

  $scope.$on('$destroy', function () {
    watch()
    watch1()
    watch2()
    watch3()
    watch4()
    watch5()
    watch6()
  })

  load()

  vm.addSegmentation = function () {
    BundleService.addBundleSegmentation($stateParams.id, vm.segmentationId).then(
      function () {
        BundleService.listBundleSegmentation($stateParams.id).then(function (result) {
          vm.bundleSegmentations = generateType(result.results)
        })
      },
      function () {
        swal('This user segmentation already exists', '', 'error')
      },
    )
  }

  vm.deleteSegmentation = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: 'You really want to delete?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          BundleService.removeBundleSegmentation($stateParams.id, id).then(function () {
            BundleService.listBundleSegmentation($stateParams.id).then(function (result) {
              vm.bundleSegmentations = generateType(result.results)
            })
          })
        } else {
          return
        }
      },
    )
  }

  vm.exportCsv = function () {
    CsvService.validSafari()
    var listCsv = []

    BundleService.listBundleSegmentationUsers($stateParams.id).then(function (result) {
      var users = result.results

      for (var i = 0; i < users.length; i++) {
        listCsv.push({
          id: users[i].id,
          username: users[i].username === undefined ? '' : users[i].username,
          email: users[i].email,
          name: users[i].name === undefined ? '' : users[i].name,
        })
      }

      var csv = CsvService.convertArrayOfObjectsToCSV({
        data: listCsv,
      })

      if (csv === null) {
        return
      }

      if (CsvService.isSafari() || CsvService.isFirefox()) {
        var link = document.createElement('a')
        link.id = 'csvDwnLink'

        document.body.appendChild(link)
        window.URL = window.URL || window.webkitURL
        var csv2 = '\ufeff' + csv,
          csvData = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(csv2),
          filename = vm.model.t + '.csv'
        $('#csvDwnLink').attr({ download: filename, href: csvData })
        $('#csvDwnLink')[0].click()
        document.body.removeChild(link)
      } else {
        var filename = vm.model.t + '.csv'

        if (!csv.match(/^data:text\/csv/i)) {
          csv = 'data:text/csv;charset=utf-8,' + csv
        }

        var data = encodeURI(csv)
        var link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', filename)
        link.click()
      }
    })
  }

  function generateType(model) {
    for (var i = 0; i < model.length; i++) {
      if (model[i].k === 1) {
        model[i].type = 'Product'
      } else if (model[i].k === 2) {
        model[i].type = 'Bundle'
      } else if (model[i].k === 3) {
        model[i].type = 'Set'
      }
    }
    return model
  }

  vm.marketplaces = []
  vm.flashPack = function () {
    vm.fp = {
      bundleId: 0,
      oft: '',
      ofd: '',
      ofs: '',
      usid: 0,
    }
    $('#modalFlashPack').modal('show')
    MarketplaceService.list(0, 100).then(function (result) {
      vm.marketplaces = result.results
    })
  }

  vm.createFlashPack = function () {
    vm.fp.bundleId = vm.model.id
    vm.fp.usid = parseInt($('#e15').select2('val'))
    if ($rootScope.whitelabelConfig) {
      const mkt = vm.marketplaces.find((item) => item.host == $rootScope.whitelabelConfig.host)
      if (mkt) {
        vm.fp['mkt'] = mkt.id
      }
    } else {
      vm.fp['mkt'] = 1
    }

    BundleService.createFlashPack(
      vm.fp.bundleId,
      vm.fp.oft,
      vm.fp.ofd,
      vm.fp.ofs,
      vm.fp.usid,
      vm.fp.mkt,
    ).then(
      function (res) {
        $('#modalFlashPack').modal('hide')
        vm.cleanUpUs()
        $timeout(function () {
          var url = window.location.origin
          var html = ''
          html += ''
          html += '<h3>Offer created</h3><br />'
          html +=
            '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
          html +=
            '<li>Offer url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
            url +
            '/admin/offers/' +
            res.results.offer.id +
            '" target="_blank">' +
            url +
            '/admin/offers/' +
            res.results.offer.id +
            '</a></li>'
          html +=
            '<li>Channel Post url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
            url +
            '/publisher/channels/' +
            res.results.post['id-ch'] +
            '/channel_posts/' +
            res.results.post.id +
            '/edit' +
            '" target="_blank">' +
            url +
            '/publisher/channels/' +
            res.results.post['id-ch'] +
            '/channel_posts/' +
            res.results.post.id +
            '/edit' +
            '</a></li>'
          html +=
            '<li>Scheduled Message url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
            url +
            '/admin/scheduled_messages' +
            '" target="_blank">' +
            url +
            '/admin/scheduled_messages' +
            '</a></li>'
          html += '</ul>'
          swal({
            title: html,
            text: '',
            html: true,
          })
        }, 500)
      },
      function (error) {
        swal(error.error.message, '', 'error')
      },
    )
  }

  vm.cleanUpUs = function () {
    $('#e15').select2('val', null)
  }

  vm.loadingObj = false
  vm.newUploadObj = false
  var watch3 = $scope.$watch('vm.objFile', function (newVal, oldVal) {
    if (!newVal) {
      vm.loadingObj = false
      return
    }
    if (newVal === oldVal) {
      vm.loadingObj = false
      return
    }

    var id = Math.random().toString(16).slice(2)
    if (vm.model.id) {
      id = vm.model.id
      vm.model.id = parseInt(vm.model.id)
    }

    vm.loadingObj = true
    UploadService.save('bundles', newVal, 'obj-data', id).then(function (fileName) {
      vm.filesObj = fileName
      vm.model.obj = fileName
      vm.loadingObj = false
      vm.newUploadObj = true
      vm.glbProgress = 0
      toastr.success('Upload complete!')
    })
  })

  vm.glbProgress = 0
  $rootScope.$on('uploadProgress', function (event, data) {
    vm.glbProgress = data
    $scope.$apply()
  })
}
